import React from 'react';

import {useDataValue} from 'globals/contexts/dataContext';

import LandingSection from 'containers/experiencePage/landingSection';
// import AboutSection from 'containers/experiencePage/aboutSection';
import EventSection from 'containers/experiencePage/eventSection';
// import ShowcaseSection from 'containers/experiencePage/showcaseSection';
// import CollaborationSection from 'containers/experiencePage/collaborationSection';
import BannerSection from 'containers/experiencePage/bannerSection';

import Footer from 'containers/footer';

import './indexPage.css';

const ExperiencePage = () => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const pageContent = content['content'][currentLanguage]['pages']['experience'];
  return <div id="experience" className="page">
    <LandingSection content={pageContent['landing']} />
    {/* <AboutSection content={pageContent['about']} /> */}
    <EventSection content={pageContent['event']} />
    {/* <ShowcaseSection content={pageContent['showcase']} /> */}
    {/* <CollaborationSection content={pageContent['collaboration']} /> */}
    <BannerSection content={pageContent['banner']} />
    <Footer />
  </div>
}

export default ExperiencePage;